const config = [
    {
        component: 'ZlmNormalDetailList',
        options: {
            data: [],
        },
        events: {},
    },
]

const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    methods: {
        getData() {
            this.$request.post(`/transformToAfter/app/track/zbggOverview`, {
                bdGuid: this.$route.query.id,
            }, { showLoading: true }).then((res) => {
                this.$request.post(`/transformToAfter/app/open/bid/list`, {
                    'bdGuid': res.data.bdGuid,
                    'objectionTitle': '',
                    'pageNo': 1,
                    'pageSize': 9999,
                }).then((res2) => {
                    this.config[0].options.data = res2.data.list.map((t) => ({
                            '异议标题': t.objectionTitle,
                            '标段/包名称': t.bdName,
                            '标段/包编号': t.bdBH,
                            '异议阶段': t.objectionTitle,
                            '发起异议单位': t.startUnit,
                            '异议发起时间': this.$util.timeFormatter(t.objectionStartTime),
                            '答复状态': t.answerStatus === 1 ? '已答复' : '未答复',
                            _guid: t.guid,
                        }))

                    this.config[0].events.handleClick = (val) => {
                        this.$router.push({
                            name: 'NormalDetail',
                            query: {
                                title: '查看异议情况',
                                type: 'yiYiDetail',
                                id: val._guid,
                            },
                        })
                    }
                })
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
